export default __webpack_public_path__ + "static/media/Cera_Scaglie_Multicolore_120x120.8acaafd3.jpg";